import { useCallback, ChangeEvent } from 'react';
import { formatDocument } from '../utils/document-mask';

/**
 * Custom hook for managing document input with automatic CPF/CNPJ masking
 *
 * Features:
 * - Auto-detects CPF (11 digits) or CNPJ (14 digits)
 * - Formats dynamically as user types
 * - Limits to 18 characters (max formatted CNPJ length)
 *
 * @returns Object with handleChange function
 */
export function useDocumentMask() {
  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>, onChange: (value: string) => void) => {
      const formatted = formatDocument(e.target.value);
      const limited = formatted.slice(0, 18);
      onChange(limited);
    },
    []
  );

  return { handleChange };
}
